"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

var _constanst = require("../../../utils/constanst");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: function container(props) {
      return {
        display: "flex",
        flex: 1,
        marginBottom: props.device === "mobile" ? 80 : 0,
        "@media (max-width: 480px)": {
          marginBottom: 50
        }
      };
    },
    negativeTop: {
      marginTop: -10
    }
  };
});

var Checkbox = function Checkbox(_ref) {
  var handleChange = _ref.handleChange,
      field = _ref.field,
      fieldId = _ref.fieldId,
      defaultValue = _ref.defaultValue,
      readOnly = _ref.readOnly;
  var URL = window.location.href;
  var spl = URL.split("/");
  var device = spl.length[spl.length - 1];
  var classes = useStyles({
    device: device
  });

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      err = _useState2[0],
      setErr = _useState2[1];

  (0, _react.useEffect)(function () {
    if (field.hasError && (defaultValue === "default" || !_utils.default.existSomeCheckboxInTrue(field.attributes)) || !defaultValue && !field.allowNull) {
      setErr(_constanst.MSG_REQUIRED);
    } else {
      setErr("");
    }
  }, [field, field.hasError, defaultValue, field.allowNull]);

  var handleIntoChange = function handleIntoChange(e, idx) {
    var tmp = field.attributes.map(function (f, i) {
      if (i === idx) {
        f.value = e.target.checked;
      }

      return f;
    });
    handleChange(fieldId, tmp, "checkbox");
  };

  var defaultStyles = {
    marginTop: 15
  };
  var style = !field.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(field.customStyles);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(_core.FormControl, {
    component: "fieldset",
    error: err !== "" ? true : false
  }, /*#__PURE__*/React.createElement(_core.FormGroup, {
    row: true,
    style: style
  }, field === null || field === void 0 ? void 0 : field.attributes.map(function (atr, i) {
    return /*#__PURE__*/React.createElement(_core.FormControlLabel, {
      key: i,
      control: /*#__PURE__*/React.createElement(_core.Checkbox, {
        checked: atr.value,
        disabled: readOnly,
        onChange: function onChange(e) {
          return handleIntoChange(e, i);
        },
        id: fieldId || "",
        color: "primary"
      }),
      label: atr.labelInside
    });
  })), err !== "" && /*#__PURE__*/React.createElement(_core.FormHelperText, {
    className: classes.negativeTop
  }, _constanst.MSG_REQUIRED)));
};

var _default = Checkbox;
exports.default = _default;